import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SimpleReportComponent } from '../simple-report/simple-report.component';

interface ReportType {
  id: number,
  name: string
}

@Component({
    selector: 'app-report-menu',
    templateUrl: './report-menu.component.html',
    styleUrls: ['./report-menu.component.scss'],
    standalone: false
})
export class ReportMenuComponent implements OnInit {
  private router = inject(Router);

  @ViewChild(SimpleReportComponent) simpleReport: SimpleReportComponent;

  // loanSchemeList: LoanScheme[] = new Array;
  // companyList: Company[] = new Array;
  // startDate: Date;
  // endDate: Date;

  // primayReportList = ["Cash Book", "List Hutang", "Stock"];
  // otherReportList = ["Stamp Report", "S/C Report", "Duit Lebih Report", "Asset Report", "Hutang", "Simpan Report", "Commission Report"];

  // selectedCompany: number;
  // selectedReport: string;
  isCollapsed = false;
  isReady = false;

  ngOnInit(): void {

  }

  goToStockReport() {
    this.router.navigateByUrl('/stockReport');

  }

}